import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/MedicalServices';
import Tooltip from '@mui/material/Tooltip';

const CreateCaseButton = props => {
  const {iconOnly, Icon} = props;
  const navigate = useNavigate();
  const patientId = (
    isString(props.patientId) || isNumber(props.patientId)
    ? props.patientId
    : get(props, 'patient.id')
  ) || '';
  const url = `/providers/cases/new?patientId=${patientId}`;
  const onClick = () => navigate(url);
  const childProps = {
    onClick,
    disabled: !patientId,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly ? null : (props.Icon ? <Icon/> : <AddIcon/>),
    fullWidth: props.fullWidth || null,
  };
  return (
    iconOnly
    ? <Tooltip title='Create Case'>
      <IconButton {...childProps} sx={{padding: 0}}>
        {props.Icon ? <Icon/> : <AddIcon/>}
      </IconButton>
    </Tooltip>
    : <Button {...childProps}>
      Create Case
    </Button>
  );
};

CreateCaseButton.defaultProps = {
  iconOnly: false,
};

CreateCaseButton.propTypes = {
  patient: PropTypes.object,
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // either this or the patient
  iconOnly: PropTypes.bool,
};

export default CreateCaseButton;

